import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { screen } from '../../variables';

export default function Button(props) {
  const {
    className,
    label,
    icon,
    margin,
    small,
    customMobileMargin,
    loggedIn,
    onClick,
    allwaysBig,
    color,
    backgroundColor,
    fontWeight,
    ref,
    href,
    reverse,
    iconColor,
    iconColorHover,
    alert,
    style,
  } = props;

  const TheButton = () => {
    return (
      <StyledButton
        type="button"
        className={className}
        margin={margin}
        small={small}
        customMobileMargin={customMobileMargin}
        loggedIn={loggedIn}
        onClick={onClick}
        allwaysBig={allwaysBig}
        color={color}
        backgroundColor={backgroundColor}
        fontWeight={fontWeight}
        ref={ref}
        reverse={reverse}
        iconColor={iconColor}
        iconColorHover={iconColorHover}
        alert={alert}
        label={label}
        style={style}
      >
        {icon}
        {label}
      </StyledButton>
    );
  };

  return href ? (
    <StyledLink to={href}>
      <TheButton />
    </StyledLink>
  ) : (
    <TheButton />
  );
}

const StyledButton = styled.button`
  background-color: ${(props) => props.backgroundColor || '#13a583'};
  border: 1px solid ${(props) => props.backgroundColor || '#13a583'};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 3px 12px rgba(0, 0, 0, 0.08),
    0px 1px 6px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  font-family: 'Nunito', sans-serif;
  font-weight: ${(props) => props.fontWeight || '400'};
  font-size: ${(props) => (props.small ? '18px' : '22px')};
  font-style: normal;
  line-height: ${(props) => (props.small ? '25px' : '30px')};
  display: flex;
  align-items: center;
  text-align: center;
  color: ${(props) => props.color || '#fff'};
  outline: none;
  padding: ${(props) => (props.small ? '7px 17px' : '12px 20px')};
  margin: ${(props) => props.margin || '0'};
  cursor: pointer;
  transition: 0.1s;

  @media (max-width: ${screen.tablet}px) {
    font-size: ${(props) => (props.allwaysBig ? '22px' : '18px')};
    line-height: ${(props) => (props.allwaysBig ? '30px' : '25px')};
    padding: ${(props) =>
      props.allwaysBig ? '12px 20px' : '9px 20px 7px 20px'};
    margin: ${(props) => props.customMobileMargin || props.margin || '0'};
  }

  ${(props) =>
    props.loggedIn &&
    ` background-color: #fff;
      color: #3D403F;
      border: 1px solid #13A583;
  `};

  svg {
    margin-right: ${(props) => (props.label ? '12px' : '0')};
    fill: ${(props) => props.iconColor || props.color || '#fff'};
  }

  &:hover {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14),
      0px 1px 10px rgba(0, 0, 0, 0.12);

    ${(props) =>
      props.reverse
        ? ` background-color: #13a583;
            color: #fff;
            border: 1px solid #13a583;

            svg {
              fill: ${props.iconColorHover || '#fff'};
            }
          `
        : `
            background-color: #40D6B3;
            color: #fff;
            border: 1px solid #40D6B3;

            svg {
              fill: ${props.iconColorHover || '#fff'};
            }
          `};

    ${(props) =>
      props.alert &&
      ` background-color: #f31c50;
      color: #fff;
      border: 1px solid #f31c50;

      svg {
        fill: #fff;
      }
    `}
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;
